export default [
  {
    title: 'Mission',
    customIcon: 'MissionSVG',
    children: [
      {
        title: 'Mission Group List',
        route: 'custom-module',
        path: '/custom-module/mission',
      },
    ],
  },
];
